<template>
  <ui-collapse
    class="currency-menu"
    data-test="currency-menu"
    :collapse-id="`collapse-currency`"
  >
    <template #ui-collapse-icon-start>
      <div
        class="currency-icon"
        :class="currentCurrency && currentCurrency.code"
        data-allow-mismatch
      >
        {{ currentCurrency && currentCurrency.symbol }}
      </div>
    </template>
    <template #ui-collapse-title>
      <div data-allow-mismatch>
        <translate tag="em"> Currency </translate>
        <span data-allow-mismatch>
          {{ currentCurrency && currentCurrency.name }}
        </span>
      </div>
    </template>
    <template #ui-collapse-body>
      <div class="currency-list">
        <currency-switch @click.prevent="emit('click', $event)" />
      </div>
    </template>
  </ui-collapse>
</template>

<script setup lang="ts">
import { useCurrencyStore } from '~/stores/useCurrencyStore'

const emit = defineEmits<(e: 'click', $event: Event) => void>()

const currencyStore = useCurrencyStore(usePinia())

const currencies = computed(() => currencyStore.currencies)

const currentCurrency = computed(() => {
  return currencies.value && currencies.value[currencyStore.currentCurrencyCode]
})
</script>

<style scoped>
.currency-menu :deep(.currency-icon) {
  height: auto;
  margin-right: 0;
  text-align: center;
  width: 1.5em;
}

.currency-icon :deep(.spinner) {
  height: 1.2em;
  width: 1.2em;
  margin: auto;
  display: flex;
}

.error {
  color: var(--colour-red);
}
</style>
